import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function D() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('solar_panel_175w');
    const { locale } = useRouter();
    const IMG1_MAP: any = {
        us: {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717124854511/4_1.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717124863087/4_1_M.jpg',
        },
        de: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1729061450013/design_de_1_pc.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1729061449728/design_de_1_h5.png',
        },
        fr: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1729062126193/design_fr_1_pc.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1729062125772/design_fr_1_h5.png',
        },
        es: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1729061450893/design_es_1_pc.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1729061450715/design_es_1_h5.png',
        },
        it: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1729062127246/design_it_1_pc.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1729062127442/design_it_1_h5.png',
        },
    };
    const IMG1 = IMG1_MAP[locale] || IMG1_MAP.us;
    const IMG2_MAP: any = {
        us: {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717124874120/4_2.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717124884621/4_2_M.jpg',
        },
        de: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1729061450531/design_de_2_pc.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1729061450246/design_de_2_h5.png',
        },
        fr: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1729062126723/design_fr_2_pc.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1729062125888/design_fr_2_h5.png',
        },
        es: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1729565938546/ES-PC.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1729565938151/ES-M.png',
        },
        it: {
            pc: 'https://websiteoss.ecoflow.com/upload/image/1729062126960/design_it_2_pc.png',
            h5: 'https://websiteoss.ecoflow.com/upload/image/1729062126440/design_it_2_h5.png',
        },
    };
    const IMG2 = IMG2_MAP[locale] || IMG2_MAP.us;
    const IMGS = [
        IMG1,
        IMG2,
        {
            pc: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717124894509/4_3.jpg',
            h5: 'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717124903585/4_3_M.jpg',
        },
    ];

    return (
        <div className={`sp-175w-D sp-175w-common ${css['sp-175w-D']}`}>
            <div className="info">
                <p className="subtitle">{t('D_subtitle')}</p>
                <p className="title">{t('D_title')}</p>
                <p className="desc">{t('D_desc')}</p>
            </div>
            <ul className="imgs">
                {[1, 2, 3]?.map((img: any, k: number) => (
                    <li className={`img img-${k}`} key={k}>
                        <EFPicture src={IMGS[k].pc} srcPad={IMGS[k].h5} srcMobile={IMGS[k].h5} alt={t('D_title')} />
                    </li>
                ))}
            </ul>
        </div>
    );
}
